<div class="container-fluid">
    <!-- For Selecting notes by lecture -->
    <div class="row">
        <div class="col-12">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Select by lecture</mat-label>
                <mat-select name="Lectures" [(ngModel)]="selectedOption" (ngModelChange)="selectByLecture()">
                    <mat-option value="0">This Lecture</mat-option>
                    <mat-option value="1">All Lectures</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <!--  -->

    <!-- Spinner -->
    <div align="center" *ngIf="spinner" class="mt-3">
        <mat-spinner [diameter]="30"></mat-spinner>
    </div>
    <!--  -->

    <!-- For Empty Notes -->
    <div *ngIf="emptyNote">
        <p class="text-center">{{message}}</p>
    </div>
    <!--  -->

    <!-- For displaying notes -->
    <div class="row" style="height: 60vh; max-height: 60vh; overflow: auto;" *ngIf="!emptyNote">
        <div class="col-12">
            <div class="row shadow rounded border mb-3 mx-3 p-2" *ngFor="let note of allNotes">
                <div class="col-9">
                    <button class="btn btn-sm btn-dark" style="font-size: 10px;">{{note.video_timestamp}}</button><br>
                    <div class="d-flex mt-1">
                        <div>
                            <mat-icon class="mr-2 mt-2" style="font-size: 14pt;">topic</mat-icon>
                        </div>
                        <div>
                            <small>{{note.topic}}</small><br>
                            <small>{{note.resource}}</small><br>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <small class="text-danger" style="cursor: pointer;"
                        (click)="deleteResourceNote(note.resource_note_id)"><mat-icon>delete_forever</mat-icon></small>
                    <small style="cursor: pointer;" (click)="editNote(note)"><mat-icon>edit_note</mat-icon></small>
                </div>
                <p class="mt-2">{{note.note}}</p>
            </div>
        </div>
    </div>
    <!--  -->

    <!-- For adding notes -->
    <div class="row" style="width: 95% !important;">
        <div class="col-12" align="right">
            <mat-icon class="material-symbols-outlined" style="font-size: 50px; cursor: pointer;" (click)="addNote()">
                add_circle
            </mat-icon>
        </div>
    </div>
    <!--  -->
</div>